<template>
  <v-container class="pa-0">
    <background />
    <famous-saying />
    <challenge-progress />
    <reward />
  </v-container>
</template>
<script>
import Background from "../../components/home/Background.vue";
import ChallengeProgress from '../../components/home/ChallengeProgress.vue';
import FamousSaying from '../../components/home/FamousSaying.vue';
import Reward from '../../components/home/Reward.vue';

export default {
  components: { Background, ChallengeProgress, FamousSaying, Reward },
  name: "Home",
};
</script>
<style lang="scss" scoped>
.homeTitle{
  padding: 20px;
  color: #FFB5CC;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}
</style>